import React, { useState, Fragment } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useTranslation } from "react-i18next"
import { documentsActions } from "../../actions/documentsActions"
import { SketchPicker } from "react-color"
import { makeStyles, Typography, Tooltip } from "@material-ui/core"

const useStyles = makeStyles((theme) => ({
	tagList: {
		maxHeight: 270,
		overflowY: "scroll",
	},
}))

const ColorPickerList = ({}) => {
	const classes = useStyles()
	const tagsApi = useSelector((state) => state.tags.custom_tags)
	const authentication = useSelector((state) => state.authtentication)
	const dispatch = useDispatch()
	const [idEditing, setIdEditing] = useState(null)
	const [nameEditing, setNameEditing] = useState("")
	const [colorIdEditing, setColorIdEditing] = useState("")

	const [t] = useTranslation("global")

	const [verColorPicker, setVerColorPicker] = useState(false)
	const eliminar = (id) => {
		//const listAct = lista.filter((list) => list.id !== id);
		//setLista(listAct);
		//Call to delete action
		console.log(id)
		dispatch(documentsActions.deleteTagAction(id))
	}

	const edit = (tag_id, name, color_id) => {
		setIdEditing(tag_id)
		setNameEditing(name)
		setColorIdEditing(color_id)
	}
	const cancelEdit = () => {
		setIdEditing(null)
		setNameEditing("")
		setColorIdEditing("")
	}
	const save = () => {
		dispatch(documentsActions.setPriorityCustomTagAction(nameEditing, colorIdEditing, idEditing))
		cancelEdit()
	}

	return (
		<Fragment>
			<div className="row mt-3">
				<div className={`${classes.tagList} form-group`}>
					{tagsApi.tags.map((list) =>
						list.id != "default_tag_0" && list.id !== "default_tag_1" && list.id !== "default_tag_2" ? (
							<div
								className="alert alert-dismissible alert-black-color"
								style={{ float: "left", display: "block", padding: "15px", width: "100%" }}
								key={list.id}
							>
								<div style={{ float: "left", display: "inline-block", width: "calc(100% - 80px)" }}>
									<span>
										<b>{t("tag.name")}:</b>
										{idEditing === list.id ? (
											<input
												type="text"
												value={nameEditing}
												onChange={(e) => {
													e.preventDefault()
													setNameEditing(e.target.value)
												}}
												onBlur={(e) => {
													setNameEditing(e.target.value?.trim())
												}}
												maxLength={100}
											/>
										) : (
											<Tooltip title={list.name} placement="top">
												<Typography noWrap>{list.name}</Typography>
											</Tooltip>
										)}
									</span>
									<br />
									<span>
										<b>{t("tag.selected-color")}:</b>
										{idEditing === list.id ? (
											<Fragment>
												<input type="text" value={colorIdEditing} readOnly={true} />
												<SketchPicker
													nombre={nameEditing}
													color={colorIdEditing}
													onChange={(cambiarColor) => setColorIdEditing(cambiarColor.hex)}
												/>
											</Fragment>
										) : (
											<em>{list.color_id}</em>
										)}
									</span>
									<p>
										<button
											className="btn btnRefreshTermsList rounded-pill btnColorFilter"
											style={{ padding: "4px", backgroundColor: list.color_id, color: "rgb(255, 255, 255)" }}
										>
											&nbsp;
										</button>
									</p>
								</div>
								<div style={{ float: "right", display: "inline-block", width: "80px" }}>
									{idEditing === list.id ? (
										<Fragment>
											<button
												disabled={nameEditing === "" || colorIdEditing === "" ? true : false}
												className="btn btn-danger btn-sm"
												style={{ float: "right", marginBottom: "5px" }}
												onClick={(e) => {
													e.preventDefault()
													save()
												}}
											>
												{t("tag.button-text")}
											</button>
											<button
												className="btn btn-danger btn-sm"
												style={{ float: "right", marginTop: "5px" }}
												onClick={(e) => {
													e.preventDefault()
													cancelEdit()
												}}
											>
												{t("tag.cancel-button-text")}
											</button>
										</Fragment>
									) : list.owner_id === authentication.user?.token.userid ? (
										<Fragment>
											{/*  <button className="btn btn-danger btn-sm" style={{float: 'right', marginBottom: "5px"}} onClick={() => eliminar(list.id)}>
                                    Delete
                                </button>
                                */}
											<button
												className="btn btn-danger btn-sm"
												style={{ float: "right", marginTop: "5px" }}
												onClick={() => edit(list.id, list.name, list.color_id)}
											>
												{t("tag.edit-button-text")}
											</button>
										</Fragment>
									) : null}
								</div>
							</div>
						) : null
					)}
				</div>
			</div>
		</Fragment>
	)
}

export default ColorPickerList
